import React from "react";
import { Archive, ScrollText, Stamp } from "lucide-react";

const ITEMS = [
    {
        icon: Archive,
        label: "Custody",
        body: "Custody controls the evidence.",
        sub: "Evidence stays at source. Only metadata and refs travel.",
    },
    {
        icon: ScrollText,
        label: "Authority",
        body: "Authority governs the action.",
        sub: "Authorised roles decide. AI may draft, compare or recommend.",
    },
    {
        icon: Stamp,
        label: "Receipts",
        body: "Receipts prove what happened.",
        sub: "KATLAS signs the governed action — not the raw prompt corpus.",
    },
];

export const CARTriad = () => (
    <section
        data-testid="car-triad"
        className="border-y border-slate-200 bg-slate-900 text-slate-100"
    >
        <div className="mx-auto max-w-7xl px-6 lg:px-10 py-12 grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-slate-800">
            {ITEMS.map((it) => (
                <div key={it.label} className="px-0 md:px-8 first:pl-0 last:pr-0 py-6 md:py-2">
                    <div className="flex items-center gap-3">
                        <it.icon className="h-5 w-5 text-emerald-400" />
                        <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-slate-400">
                            {it.label}
                        </span>
                    </div>
                    <p className="mt-3 font-heading text-xl font-semibold text-white">{it.body}</p>
                    <p className="mt-2 text-sm text-slate-400 leading-relaxed max-w-xs">
                        {it.sub}
                    </p>
                </div>
            ))}
        </div>
    </section>
);

export default CARTriad;
